import { useCalculate } from "@/modules/dwelling/containers/DwellingEstimateContainer/Calculate/useCalculate.tsx";
import styles from "@/modules/dwelling/containers/DwellingEstimateContainer/DwellingEstimateTable/DwellingEstimateTable.module.scss";

export const DwellingEstimateTableTotal = ({
  roomName,
  name,
}: {
  roomName: string;
  name: string;
}) => {
  const { costingCalculate, handleCountRepair } = useCalculate();

  return (
    <div className={styles.totalSection}>
      <div className={styles.totalInfoLine}>
        Total des réparations {roomName?.toLocaleLowerCase()} :
        <strong> {handleCountRepair(name)} unités</strong>
      </div>
      <div className={styles.totalInfoLine}>
        Montant HT :{" "}
        <strong>
          {costingCalculate.elements[name].total.preTaxPrice.toFixed(2)} €
        </strong>
      </div>
      <div className={styles.totalInfoLine}>
        Vétusté déduite :{" "}
        <strong>
          -
          {costingCalculate.elements[name].total.dilapidationDeducted.toFixed(
            2,
          )}{" "}
          €
        </strong>
      </div>
      <div className={styles.totalInfoLine}>
        TVA :{" "}
        <strong>
          {costingCalculate.elements[name].total.taxAmount.toFixed(2)} €
        </strong>
      </div>
      <div className={styles.totalInfoLine}>
        Montant TTC :{" "}
        <strong>
          {costingCalculate.elements[name].total.total.toFixed(2)} €
        </strong>
      </div>
    </div>
  );
};
